import React, { useState } from "react";

const TceContext = React.createContext([{}, () => {}]);

const TceProvider = props => {
  const [state, setState] = useState({
    data: null,
    loading: false
  });
  return (
    <TceContext.Provider value={[state, setState]}>
      {props.children}
    </TceContext.Provider>
  )
}

export { TceContext, TceProvider };
